// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { BaseItem, ColumnData } from '../BaseItem';
import { ColumnParams } from '../ColumnParams';
import { QuickTableComparingType } from '@shared/utils/QuickTableMisc/QuickTableComparingType';
import { TableTotalsVisibility } from '../TableTotalsVisibility';
import { QTAlignment } from '../../elements/QuickTable/QuickTableColumn';
import { Resources } from '@shared/localizations/Resources';
export class OptionChainStrikesListTableItem extends BaseItem {
    get version() {
        var _a, _b;
        return (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.version) !== null && _b !== void 0 ? _b : null;
    }
    get strike() {
        var _a, _b;
        return (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.strikePrice) !== null && _b !== void 0 ? _b : -1;
    }
    constructor(option) {
        super(null);
        this._option = option;
    }
    getStrikePriceTooltip() {
        if (isNullOrUndefined(this._option) || !isValidString(this._option.version)) {
            return null;
        }
        const underlierDisplayName = this._option.underlierDisplayName;
        if (!isValidString(underlierDisplayName)) {
            return null;
        }
        return Resources.getResource('panel.optionChain.strike.infoIconTooltip', [underlierDisplayName]);
    }
    GetItemId() {
        const versionStr = isValidString(this.version) ? this.version : '';
        return this.strike.toString() + versionStr;
    }
    getColumnValue(column) {
        switch (column) {
            case OptionChainStrikesListTableItem.STRIKE_COL_INDEX:
                return this.strike;
            default:
                return undefined;
        }
    }
    getColumnData(column) {
        const value = this.getColumnValue(column);
        return new ColumnData(value, value.toString());
    }
    // ITableItem methods
    ColumnCount() {
        return OptionChainStrikesListTableItem.columnsParams.length;
    }
    GetColumnParams(i) {
        const par = OptionChainStrikesListTableItem.columnsParams[i];
        par.Hidden = par.DefaultHidden;
        return par;
    }
    GetDataType(columnIndex) {
        return OptionChainStrikesListTableItem.dataTypes[columnIndex];
    }
}
// ITableItem methods end
// #region static table parame
OptionChainStrikesListTableItem.STRIKE_COL_INDEX = 0;
OptionChainStrikesListTableItem.columnsParams = [
    new ColumnParams('panel.optionChain.strike', 100, QTAlignment.Left, TableTotalsVisibility.None, true, false)
];
OptionChainStrikesListTableItem.dataTypes = [QuickTableComparingType.String];
